const PERMITTED_IMAGE_TYPES = /^(jpe?g|png|bmp|gif)$/i
const PERMITTED_DOCUMENT_TYPES = /^(pdf|docx?|xlsx?|txt|rtf|csv)$/i

export const getFileExtension = function (file) {
  const extPos = file.name.lastIndexOf('.')
  const ext = file.name.substring(extPos + 1)
  return ext
}

export const validateImageType = function (file) {
  const ext = getFileExtension(file)
  return PERMITTED_IMAGE_TYPES.test(ext)
}

export const validateDocumentType = function (file) {
  const ext = getFileExtension(file)
  return PERMITTED_DOCUMENT_TYPES.test(ext)
}

export const validateFileType = function (file) {
  return validateImageType(file) || validateDocumentType(file)
}



// WEBPACK FOOTER //
// ./src/util/FileValidation.js